import React from "react";
import axios from "axios";
import { toast } from "sonner";
import { Bookmark, Trash2 } from "lucide-react";
import { API } from "../../config/api";

export const SavedReportsList = ({ views = [], onOpen, onChanged }) => {
  const remove = async (e, view_id) => {
    e.stopPropagation();
    if (!window.confirm("Delete this saved report?")) return;
    try {
      await axios.delete(`${API}/reports/saved-views/${view_id}`);
      toast.success("Removed");
      onChanged?.();
    } catch {
      toast.error("Could not delete");
    }
  };

  if (!views.length) {
    return (
      <div data-testid="saved-empty" className="rounded-xl border border-dashed border-slate-200 bg-slate-50/60 p-6 text-center">
        <Bookmark className="w-5 h-5 text-slate-300 mx-auto" />
        <p className="mt-2 text-xs text-slate-500">Save a snapshot to access it from here anytime.</p>
      </div>
    );
  }
  return (
    <div data-testid="saved-reports-list" className="rounded-xl border border-slate-200 bg-white divide-y divide-slate-100">
      {views.map((v) => (
        <div
          key={v.view_id}
          data-testid={`saved-${v.view_id}`}
          className="group flex items-center justify-between gap-3 px-4 py-3 hover:bg-slate-50 transition-colors"
        >
          <button onClick={() => onOpen?.(v.report_id)} className="min-w-0 flex-1 text-left">
            <div className="text-sm font-medium text-slate-900 truncate flex items-center gap-1.5">
              <Bookmark className="w-3.5 h-3.5 text-amber-500" />
              {v.name}
            </div>
            <div className="text-[11px] text-slate-500 mt-0.5">{v.template_id}</div>
          </button>
          <button
            onClick={(e) => remove(e, v.view_id)}
            className="p-1.5 rounded-md text-slate-400 hover:text-rose-600 hover:bg-rose-50 opacity-0 group-hover:opacity-100 transition"
            title="Delete saved view"
          >
            <Trash2 className="w-4 h-4" />
          </button>
        </div>
      ))}
    </div>
  );
};

export default SavedReportsList;
